<template>
  <div v-if="currentPoint == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar punto de interés</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <point-form :entity="currentPoint" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import PointForm from "./PointForm.vue";


    const store = useStore();
    const route = useRoute();


    const getCurrentPoint = async (id) => {
      return await store.dispatch("point/getPointById", id);
    };

    const currentPoint = computed(() => {

      if(!store.state.point.currentPoint) return null
      let point = store.state.point.currentPoint
      if( point.type && point.type['@id']){
        point.type = point.type['@id']
      }
      if( point.experience && point.experience['@id']){
        point.experience = point.experience['@id']
      }
      return point
    });

    onMounted(() => {
      getCurrentPoint(route.params.id)
    });



</script>
